export default {
      id: "bullet-arrow-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }